<script setup>
import VersementListItem from '@/components/fiche-aim/fiche-aim/versements/versementList/versement-list-item.vue'
import SInfoMontant from '@/components/global/s-info-montant.vue'

defineEmits(['delete-versement'])
</script>

<template>
  <tbody class="my-4">
    <tr>
      <th class="primary lighten-5 text-left text-body-1 pt-3" colspan="1">
        {{ dateVersement }}
      </th>
      <th class="primary lighten-5" colspan="3" />
    </tr>
    <versement-list-item
      v-for="versement in groupeVersement.versements"
      :key="versement.versementId"
      :versement="versement"
      @delete-versement="$emit('delete-versement', versement)"
    />
    <tr v-if="groupeVersement.versements.length > 1">
      <td colspan="2" class="text-right text-body-1">Total</td>
      <td style="min-width: 15%" colspan="2" class="text-left text-body-1">
        <s-info-montant :montant="montantVerseADate" />
      </td>
    </tr>
  </tbody>
</template>

<script>
import moment from 'moment/moment'

export default {
  name: 'groupe-date-versement-list-item',
  props: {
    groupeVersement: {
      type: Object,
      required: true,
    },
  },
  computed: {
    dateVersement() {
      return moment(this.groupeVersement.date).format('Do MMM YY')
    },
    montantVerseADate() {
      let sum = 0
      this.groupeVersement.versements.forEach((versement) => {
        versement.lignesVersements.forEach((l) => (sum += l.montant))
      })
      return sum
    },
  },
}
</script>

<style scoped></style>
